export default [
    {
        path: 'baixa',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-baixa' */
            '@/views/almoxarifado/baixa/Index'
        ),
        redirect: 'baixa/index',
        children: [
            {
                name: 'almoxarifado-baixa-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-baixa' */
                    '@/views/almoxarifado/baixa/List.vue'
                ),
            },
        ],
    },
]